export default "__VITE_ASSET__DvwZHt0e__"